import { bus } from '@/lib/eventBus';

export default {
  methods: {
    attachRotationHandlers() {
      this.zoomContainerEl = this.$el.closest('.modal-canvas__inner-wrap')
        || this.$el.closest('.editor__zoom-content');
      if (this.zoomContainerEl) {
        /*
          Get the current border applied to the zoom container to be used
          when calculating bounding rect.
        */
        const styles = getComputedStyle(this.zoomContainerEl);
        this.zoomBorderInlineStartWidth = styles?.borderInlineStartWidth
          ? parseInt(styles.borderInlineStartWidth, 10)
          : 0;
        this.zoomBorderBlockStartWidth = styles?.borderBlockStartWidth
          ? parseInt(styles.borderBlockStartWidth, 10)
          : 0;
      }
      this.gridItemEl = this.moduleElement.closest('.vue-grid-item');
      this.editorStageEl = this.$el.closest('.modal-canvas__stage')
        || this.$el.closest('.editor__stage');

      bus.on('module:rotation-start', this.onRotationStart);
      bus.on('module:rotation-change', this.onRotationChange);
      bus.on('module:rotation-end', this.onRotationEnd);
    },
    removeRotationHandlers() {
      bus.off('module:rotation-start', this.onRotationStart);
      bus.off('module:rotation-change', this.onRotationChange);
      bus.off('module:rotation-end', this.onRotationEnd);
    },
    /**
     * Gets the unscaled dimensions of the current grid item bounding rect.
     */
    getModuleRectNotScaled() {
      if (!this.moduleElement) return null;
      if (!this.gridItemEl) return null;
      if (!this.zoomContainerEl) return null;
      const zoomRect = this.zoomContainerEl.getBoundingClientRect();
      const rect = this.gridItemEl.getBoundingClientRect();
      const rectXCenter = rect.left + (rect.right - rect.left) / 2;
      const rectYCenter = rect.top + (rect.bottom - rect.top) / 2;
      const centerX = (rectXCenter - zoomRect.left) / this.scale - this.zoomBorderInlineStartWidth;
      const centerY = (rectYCenter - zoomRect.top) / this.scale - this.zoomBorderBlockStartWidth;
      return {
        width: this.gridItemEl.offsetWidth,
        centerX,
        centerY,
      };
    },
  },
};
